/* Reconciled response scores. Never reuse Judge.me's cached stars/counts. */
(() => {
  const cache = new Map(), queue = []; let active = 0;
  const run = () => { while (active < 4 && queue.length) { active++; queue.shift()().finally(() => { active--; run(); }); } };
  function score(id) {
    if (!cache.has(id)) cache.set(id, new Promise(resolve => {
      queue.push(async () => { try {
        const r = await fetch('https://orderops-dev-web-production.up.railway.app/api/rr/reviews/stats?productId=' + encodeURIComponent(id), {credentials:'omit',signal:AbortSignal.timeout(12000)});
        if (!r.ok) throw Error(); const data = await r.json();
        resolve(data.scoredResponses > 0 && Number.isFinite(data.score) && data.score >= 50 && data.score <= 100 ? data : null);
      } catch { resolve(null); } }); run();
    })); return cache.get(id);
  }
  function load(el) { if(el.dataset.ervpLoaded) return; el.dataset.ervpLoaded='true';
    score(el.dataset.ervpReviewScore).then(data => { if(!data)return;
      const percentage=Math.round(data.score), count=data.scoredResponses;
      const value=document.createElement('span'), total=document.createElement('span');
      value.textContent=percentage+'%'; total.textContent='('+count+')';
      const icon=document.createElementNS('http://www.w3.org/2000/svg','svg');
      for(const [name,value] of Object.entries({viewBox:'0 0 24 24',width:'20',height:'20',fill:'none',stroke:'currentColor','stroke-width':'2','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'})) icon.setAttribute(name,value);
      icon.innerHTML='<path d="M7 10v12M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H3a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L11 2a3.13 3.13 0 0 1 4 3.88Z"/>';
      // Match the storefront's green add-to-cart button; keep the badge compact.
      Object.assign(el.style,{display:'inline-flex',alignItems:'center',gap:'0.3em',color:'#0b7a38',fontWeight:'700',whiteSpace:'nowrap'});
      icon.style.flexShrink='0';
      el.replaceChildren(value,icon,total);
      el.setAttribute('aria-label',percentage+' percent customer score from '+count+' '+(count===1?'rating':'ratings')+'. Read reviews.');
      el.title='See what other RV owners think.';
      el.hidden=false;
    });
  }
  // Hidden placeholders have no intersection area; observe their visible parent.
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if(entry.isIntersecting) {entry.target.querySelectorAll('[data-ervp-review-score]').forEach(load);observer.unobserve(entry.target);}
  }), {rootMargin:'200px'});
  document.querySelectorAll('[data-ervp-review-score]').forEach(el => observer.observe(el.parentElement));
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-ervp-review-score]').forEach(el=>observer.observe(el.parentElement)));

  // Searchanise draws its own cards, so add the score and real buyer count to them here.
  // Counts come from ervp-buyer-counts.json (written nightly by ERVP tools/pdp-social-proof); never hardcode them.
  const assetBase = (document.currentScript && document.currentScript.src || '').split('ervp-review-scores.js')[0];
  let buyerCounts;
  function loadBuyerCounts() {
    if (!buyerCounts) buyerCounts = !assetBase ? Promise.resolve({}) :
      fetch(assetBase + 'ervp-buyer-counts.json?d=' + new Date().toISOString().slice(0, 10), {credentials:'omit'})
        .then(r => r.ok ? r.json() : {}).catch(() => ({}));
    return buyerCounts;
  }
  function buyerBadge(id, count) {
    const badge = document.createElement('span'), faces = document.createElement('span'), text = document.createElement('span'), number = document.createElement('strong');
    badge.className = 'ervp-buyer-proof';
    Object.assign(badge.style, {display:'inline-flex',alignItems:'center',gap:'6px',fontSize:'13px',color:'#374151',whiteSpace:'nowrap'});
    faces.setAttribute('aria-hidden', 'true'); faces.style.display = 'inline-flex';
    // Same trio as the product page: product id modulo 100, plus offsets, on a 10x10 sprite.
    const first = Number(BigInt(id) % 100n);
    [0, 37, 71].forEach((offset, position) => {
      const index = (first + offset) % 100, face = document.createElement('span');
      Object.assign(face.style, {boxSizing:'content-box',width:'22px',height:'22px',borderRadius:'50%',border:'2px solid #fff',
        background:'#e5e7eb url(' + assetBase + 'ervp-buyer-avatars.webp) ' + (index % 10 * -22) + 'px ' + (Math.floor(index / 10) * -22) + 'px / 220px 220px no-repeat',
        marginLeft: position ? '-8px' : '0'});
      faces.appendChild(face);
    });
    number.textContent = count.toLocaleString('en-US');
    text.append(number, ' ordered');
    badge.append(faces, text);
    return badge;
  }
  function decorateSnize(card) {
    const match = /^snize-product-(\d+)$/.exec(card.id), title = card.querySelector('.snize-title');
    if (!match || !title || card.querySelector('.ervp-card-proof')) return;
    const row = document.createElement('span'), scoreEl = document.createElement('span');
    row.className = 'ervp-card-proof';
    Object.assign(row.style, {display:'flex',flexWrap:'wrap',alignItems:'center',gap:'4px 12px',margin:'4px 0'});
    scoreEl.dataset.ervpReviewScore = match[1]; scoreEl.hidden = true;
    row.appendChild(scoreEl);
    title.insertAdjacentElement('afterend', row);
    observer.observe(row);
    loadBuyerCounts().then(counts => { const count = counts[match[1]]; if (count >= 3 && row.isConnected) row.appendChild(buyerBadge(match[1], count)); });
  }
  const decorateAll = root => root.querySelectorAll && root.querySelectorAll('li.snize-product').forEach(decorateSnize);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType !== 1) return;
    if (node.matches('li.snize-product')) decorateSnize(node); else if (node.closest('li.snize-product')) decorateSnize(node.closest('li.snize-product')); else decorateAll(node);
  }))).observe(document.documentElement, {childList:true, subtree:true});
  decorateAll(document);
})();
